import toggleClass from 'utils/DOM/toggleClass'
import getById from 'utils/DOM/getById'
import checkEligibility from './checkEligibility'

function buildMemberController(member, suffix, controllers) {
  const state = {
    valid: false
  }

  return {
    getStatus: () => ({
      valid: state.valid
    }),
    validate: () => {
      let validMember = true
      const id = member.id
      const age = member.age
      const gender = member.gender
      const heightFt = controllers[`heightft${suffix}`].getStatus().value
      const heightIn = controllers[`heightin${suffix}`].getStatus().value
      const weight = controllers[`weight${suffix}`].getStatus().value

      validMember = checkEligibility({
        age,
        gender,
        heightFt,
        heightIn,
        weight
      })

      toggleClass(getById(id), 'invalid-member', !validMember)

      state.valid = validMember
    }
  }
}

export default buildMemberController
